import { useLocation } from 'react-router-dom';

import { ROUTES } from '@constants/ROUTES';
import { PAGE_TABS_DATA } from '@constants/scholarships';

import { carryExploreFilters, ExploreTab } from '@utils/exploreFilters';

import { StyledSwitcherWrap, StyledSwitcher, StyledExploreByTitle, StyledLink } from './ExploreModeSwitcher.styles';

const EXPLORE_TABS: { tab: ExploreTab; label: string; to: string; path: string }[] = [
  { tab: 'majors', label: 'MAJORS', to: ROUTES.MAJORS, path: ROUTES.MAJORS },
  { tab: 'schools', label: 'SCHOOLS', to: ROUTES.SCHOOLS, path: ROUTES.SCHOOLS },
  {
    tab: 'scholarships',
    label: 'SCHOLARSHIPS',
    to: `${ROUTES.SCHOLARSHIPS}#${PAGE_TABS_DATA.allScholarships.hash}`,
    path: ROUTES.SCHOLARSHIPS,
  },
];

interface ExploreModeSwitcherProps {
  showSwitcher?: boolean;
}

export const ExploreModeSwitcher = ({ showSwitcher = true }: ExploreModeSwitcherProps) => {
  const location = useLocation();
  const activeTab = EXPLORE_TABS.find(({ path }) => location.pathname.includes(path))?.tab;

  if (!showSwitcher) return null;

  return (
    <StyledSwitcherWrap>
      <StyledExploreByTitle component="div">Explore by:</StyledExploreByTitle>
      <StyledSwitcher data-testid="exploreTabs">
        {EXPLORE_TABS.map(({ tab, label, to }) => (
          <StyledLink
            key={tab}
            to={to}
            active={tab === activeTab}
            onClick={(event) => {
              const isNewBrowserTab = event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0;

              if (activeTab && !isNewBrowserTab) carryExploreFilters(activeTab, tab);
            }}
          >
            {label}
          </StyledLink>
        ))}
      </StyledSwitcher>
    </StyledSwitcherWrap>
  );
};
